import { useTranslation } from 'react-i18next'
import { DialogSpinner } from '../../Spinner'
import {
  invalidateDocumentCategoryCache,
  useGetDocumentCategory,
  useUpdateDocumentCategory,
} from '../../../api/document-category'
import { DocumentCategoryForm } from 'src/screens/admin/document-category/DocumentCategoryForm'
import { toast } from 'react-toastify'
import { GenericDialogLayout } from '../../GenericDialogLayout'
import { IDocumentCategory } from '../../../generated-types'
import { ShowDialogProps } from 'src/show-dialog'
import { useCallback } from 'react'

interface UpdateDocumentCategoryProps extends ShowDialogProps {
  id: EntityId
}

export const UpdateDocumentCategoryDialog: React.FC<UpdateDocumentCategoryProps> = ({ pop, id }) => {
  const { t: translate } = useTranslation(['documentcategory', 'common', 'common-api-message'])
  const { data, isLoading } = useGetDocumentCategory(id)
  const mutation = useUpdateDocumentCategory(id as EntityId)

  const onSubmit = useCallback(
    async form => {
      await mutation.mutateAsync(form, {
        onSuccess: () => {
          toast.success(translate('successfullyUpdated', { ns: 'common-api-message' }))
          invalidateDocumentCategoryCache.useGetDocumentCategories()
          invalidateDocumentCategoryCache.getDocumentCategory(id)
          pop(true)
        },
        onError: error => {
          if (error && error['data'] === 'DocumentCategoryAlreadyExists') {
            toast.warning(translate('documentCategoryAlreadyExists', { ns: 'document-category' }))
          } else {
            toast.error(translate('CannotAddDocumentCategory', { ns: 'document-category' }))
          }
        },
      })
    },
    [mutation, translate, id, pop],
  )

  if (isLoading) return <DialogSpinner size={48} />

  return (
    <GenericDialogLayout title={translate('updateDocumentCategory', { ns: 'document-category' })} pop={pop}>
      <DocumentCategoryForm onSubmit={onSubmit} onCancel={() => pop()} initialValues={data as IDocumentCategory} />
    </GenericDialogLayout>
  )
}
